import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Reasoning({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      version="1.1"
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          className={theme.stroke}
          d="M8.18518541 16.1111115s-.05925926-1.0074074.05925926-1.6592592c.11851852-.7111112.53333333-.6518519.53333333-.6518519h2.1333333c.5333334 0 .6518519-.4740741.6518519-.8888889s0-.8888889.0592592-1.54074072c.0592593-.65185185.1777778-1.06666667.1777778-1.06666667h.5925926c.4148148 0 .2370371-.53333333.2370371-.53333333l-1.0074075-1.8962963V6.86666707c0-.71111111-.1777777-2.07407407-.88888884-3.02222222C9.72592615 2.65925967 8.24444467 1.8888893 6.58518541 1.8888893c-3.02222222 0-5.45185185 2.42962963-5.45185185 5.45185185 0 .88888889.23703703 1.71851852.59259259 2.48888889.71111111 1.54074074 1.65925926 2.96296296 1.65925926 4.20740736v2.0148149"
        />
        <path
          className={theme.fill}
          d="M3.977778 8.40740781c-1.00740741-.71111111-1.00740741-2.19259259.05925926-2.78518518-.41481482-2.01481482 3.31851852-2.07407407 4.26666667-1.54074074 1.06666666.59259259 2.31111111 2.31111111.47407407 2.54814815 0 1.6-3.79259259 2.54814815-4.8 1.77777777z"
        />
      </g>
    </svg>
  )
}

Reasoning.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
